<div class="modal-header justify-content-between">
    <h4 class="modal-title header-13">
      How to Set Up the Local Agent?
    </h4>
    <div>
     <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
    </div>
  </div>
  
  <div class="modal-body mb-2">
    <ol style="margin-top: 10px;">
        <li class="mb-4"> Download <span class="light-fnt">LocalAgent.zip </span> file. <a class="link-style" (click)="downloadExtentioComponent()"> Click here </a> to download </li>
        <li class="mb-4"> Extract it to your preferred local folder. </li>
        <li class="mb-4"> Open the <span class="light-fnt"> README.MD </span> file inside the extracted folder. Follow the step-by-step guide to set up and run the local execution engine. </li>
        <li class="mb-4"> Replace the value of api.key in the <span class="light-fnt"> config/application-local.properties </span> file with your execution engine token shown below. </li>
    </ol>
    <span class="sub-title">Agent Token</span>
    <div class="d-flex justify-content-center mt-1">
        <span class="key-span"> {{ key }} </span>
        <div class="v-center text-center">
            <img src="assets/images/virtusa-icons/copy-outline.png" alt="copy" class="copy-icon" style="cursor: pointer; width: 14px; margin-left: 10px;" (click)="copyToClipboard(key)" (keydown)="copyToClipboard(key)">
        </div>
    </div>
  </div>